module.exports = __webpack_public_path__ + "static/media/map-marker-doctors-active.b72abe5b.svg";